import React, { Fragment, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Grid, Icon, IconButton, CardMedia, InputAdornment, CircularProgress } from '@mui/material';
import PageDividerText from 'src/components/customComponents/B2/PageDividerText';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import PDFRenderer from '../../../uiElements/fields/PDFRenderer';
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import { useParams } from 'react-router';
import { LoadingButton } from '@mui/lab';

function BillingFormEditDialogPayments(payment) {
	const notify = useNotify()
	const translate = useTranslate()
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [openDialogPayment, setOpenDialogPayment] = React.useState(false);
	// Dialog open document retention
	const [openPreview, setOpenPreview] = useState(false);
	const { id } = useParams();
	const [selectedFile, setSelectedFile] = useState(null);
	const [editReceipt, setEditReceipt] = useState(false);
	const [receiptNumber, setReceiptNumber] = useState(payment?.payment?.allocation_receipt || '')
	const [loadingEditReceipt, setLoadingEditReceipt] = useState(false)
	const [loadingUpdateReceipt, setLoadingUpdateReceipt] = useState(false)

	const editReceiptNumber = async () =>{
		setLoadingEditReceipt(true)
		await billingFormServices.editReceiptNumber(id,receiptNumber, payment.payment?.id).then(()=>{
			notify('ra.notification.edit_receipt_success',{type:'success'})
		}).catch(()=>{
			notify('ra.notification.edit_receipt_error',{type:'error'})
		}).finally(()=>{
			setLoadingEditReceipt(false)
			setEditReceipt(false)
		})
	}

	const updateReceiptNumber = async () =>{
		setLoadingUpdateReceipt(true)
		await billingFormServices.updateReceiptNumber(id,payment.payment.id).then(()=>{
			notify('ra.notification.update_receipt_success',{type:'success'})
		}).catch(()=>{
			notify('ra.notification.update_receipt_error',{type:'error'})
		}).finally(()=>{
			setLoadingUpdateReceipt(false)
		})
	}
	// Dialog open document retention
	const handleOpenPreview = (file) => {
		setSelectedFile(file);
		setOpenPreview(true);
	};
	const handleClosePreview = () => {
		setOpenPreview(false);
		setSelectedFile(null);
	};

	const [imageSize, setImageSize] = useState({ width: 'auto', height: 'auto' });


	// Start Dialog Payment
	const handleOpenDialogPayment = () => {
		setOpenDialogPayment(true);
	};
	const handleCloseDialogPayment = () => {
		setOpenDialogPayment(false);
	};
	// End Dialog Payment

	const handleDownloadFiles = async (files) => {
		if (files && files.length > 0) {
			for (const file of files) {
				try {
					const fileUrl = file.bucket_path;
					const fileName = file.file_name;
					const response = await billingFormServices.downloadFiles(fileUrl);
					const contentType = response.headers['content-type']                  
					const blob = new Blob([response.data], { type: contentType });
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.style.display = 'none';
					a.href = url;
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);

					// Espera 1 segundo antes de iniciar la siguiente descarga
					await new Promise((resolve) => setTimeout(resolve, 1000));
				} catch (error) {
					console.error('Error al descargar el archivo:', error);
				}
			}
		} else {
			console.error('No hay archivos para descargar.');
		}
	};
	// End Download payment file

	return (
		<React.Fragment>
			<Button variant="text" startIcon={<Icon>visibility</Icon>} onClick={handleOpenDialogPayment}>
				{translate('ra.action.see_details')}
			</Button>
			<Dialog
				onClose={handleCloseDialogPayment}
				aria-labelledby="customized-dialog-title"
				open={openDialogPayment}
				maxWidth="xl"
				className='generalDialogContainer'
			>
				<DialogTitle className='dialogTitle'>
					{translate('ra.field.payments')}
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleCloseDialogPayment}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent dividers className='generalFormStyles'>
					<Grid container spacing={3} >
						{/* start - dialog preview document */}
						<Dialog open={openPreview} onClose={handleClosePreview} maxWidth="xl" className='generalDialogContainer'>
							<DialogTitle className='dialogTitle'>
								<span>Archivo:</span> {selectedFile?.file_name}
								<IconButton
									aria-label="close"
									onClick={handleClosePreview}
									sx={{ position: 'absolute', right: 8, top: 8, color: 'grey' }}
								>
									<CloseIcon />
								</IconButton>
							</DialogTitle>

							<DialogContent dividers>
								{selectedFile?.bucket_path.includes('.pdf') ? (
									<PDFRenderer url={selectedFile.bucket_path} alt={`Vista previa PDF`} enablePagination={true} />
								) : (
									<DialogContent dividers>
										<CardMedia
											component="img"
											image={selectedFile?.bucket_path}
											alt="Vista previa"
											sx={{
												width: 'auto', // Mantiene el tamaño original de la imagen
												maxWidth: '100%', // Asegura que no sobrepase el Dialog
												maxHeight: '80vh', // Para evitar que sea demasiado grande
												objectFit: 'contain', // Evita que la imagen se deforme
												imageRendering: 'crisp-edges' // Mejora la nitidez
											}}
										/>
									</DialogContent>
								)}
							</DialogContent>

							{/* Sección de acciones para los botones */}
							<DialogActions>
								<Button
									variant="outlined"

									onClick={handleClosePreview}
								>
									Cerrar
								</Button>
								<Button
									variant="contained"
									color="primary"
									onClick={() => handleDownloadFiles([selectedFile])}
									startIcon={<DownloadIcon />}
								>
									Descargar
								</Button>
							</DialogActions>
						</Dialog>
						{/* end - dialog preview document */}


						<Grid item xs={12} md={12} lg={12} xl={12} >
							<Grid container spacing={3}>

								{payment.payment.conciliation_result ?
									<>
										<Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.status')}
												disabled={true}
												value={payment.payment.conciliation_result.status || ''}
												className="textField"
											/>
										</Grid>
										<Grid item xs={12} md={8} lg={8} xl={9} >
											{(payment.payment.conciliation_result) && (payment.payment.conciliation_result.status === "en revision" || payment.payment.conciliation_result.status === "ingresado")
												? (<div className="cobranzasStatusMessage">
													<strong>Motivo: </strong> {payment.payment.conciliation_result?.detail}
												</div>
												)
												: (payment.payment.conciliation_result && payment.payment.conciliation_result.status === "aprobado" && payment.payment.conciliation_result?.detail !== undefined)
													? (<div className="cobranzasStatusMessage">
														<div><strong>Motivo</strong>: {payment.payment.conciliation_result?.detail}</div>
														<div><strong>Fecha de extracto</strong>: {payment.payment.conciliation_result?.extract_date}</div>
														<div><strong>Monto de extracto</strong>: {payment.payment.conciliation_result?.extract_amount}</div>
														<div><strong>Referencia de extracto</strong>: {payment.payment.conciliation_result?.extract_ref}</div>
														<div><strong>Concepto de extracto</strong>: {payment.payment.conciliation_result?.extract_concept}</div>
													</div>)
													: (payment.payment.conciliation_result && payment.payment.conciliation_result.status === "aprobado" && payment.payment.conciliation_result?.detail === undefined)
														? (<div></div>)
														: (payment.payment.conciliation_result && payment.payment.conciliation_result.status === "rechazado")
															? (
																<div className="cobranzasStatusMessage">
																	<div><strong>Motivo</strong>: {payment.payment.conciliation_result?.detail}</div>
																	<div><strong>Fecha de rechazo</strong>: {payment.payment.conciliation_result?.date}</div>
																</div>
															)
															: (
																<></>
															)
											}
										</Grid>
									</>
									:
									<>
										<Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.status')}
												disabled={true}
												value={'ingresado'}
												className="textField"
											/>
										</Grid>
									</>
								}
								<Grid item xs={12} md={12} lg={12} xl={12}>
									<PageDividerText content={translate('ra.field.payment_type')} />
								</Grid>
								<Grid item xs={12} md={4} lg={4} xl={3} >
									<TextField
										size='small'
										fullWidth
										label={translate('ra.field.operation_type')}
										disabled={true}
										value={payment?.payment?.payment_type || ''}
										className="textField"
									/>
								</Grid>
								<Grid item xs={12} md={4} lg={4} xl={3} >
									<TextField
										size='small'
										fullWidth
										label={translate('ra.field.amount')}
										disabled={true}
										value={payment?.payment?.amount || ''}
										className="textField"
									/>
								</Grid>
								<Grid item xs={12} md={4} lg={4} xl={3} >
									<TextField
										size='small'
										fullWidth
										label={translate('ra.field.payment_date')}
										disabled={true}
										value={payment?.payment?.payment_date || ''}
										className="textField"
									/>
								</Grid>
							</Grid>
						</Grid>

						{/* Start Bloq Detail Payment */}
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<Grid container spacing={3}>
								<Fragment>
									{payment?.payment?.cash_info &&
										<Fragment>
											{payment?.payment?.cash_info?.name &&

												<Grid item xs={12} md={4} lg={4} xl={3} >
													<TextField
														size='small'
														fullWidth
														label={translate('ra.field.cash')}
														disabled={true}
														value={payment?.payment?.cash_info?.name || ''}
														className="textField"
													/>
												</Grid>
											}
											{payment?.payment?.cash_info?.customer_name &&
												<Grid item xs={12} md={4} lg={4} xl={3} >
													<TextField
														size='small'
														fullWidth
														label={translate('ra.field.customer_name')}
														disabled={true}
														value={payment?.payment?.cash_info?.customer_name || ''}
														className="textField"
													/>
												</Grid>
											}
										</Fragment>
									}
									{payment?.payment?.bank_info &&
										<Fragment>
											{payment?.payment?.bank_info?.name && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.bank')}
													disabled={true}
													value={payment?.payment?.bank_info?.name || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.bank_info?.coupon_number && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.coupon_number')}
													disabled={true}
													value={payment?.payment?.bank_info?.coupon_number || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.bank_info?.document_number && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.payers_document_number')}
													disabled={true}
													value={payment?.payment?.bank_info?.document_number || ''}
													className="textField"
												/>
											</Grid>}
										</Fragment>
									}

									{payment?.payment?.card_info &&
										<Fragment>
											{payment?.payment?.card_info?.customer_name && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.customer_name')}
													disabled={true}
													value={payment?.payment?.card_info?.customer_name || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.long_name && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.card')}
													disabled={true}
													value={payment?.payment?.card_info?.long_name || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.card_number && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.card_number')}
													disabled={true}
													value={payment?.payment?.card_info?.card_number || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.expiry_date && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.expiry_date')}
													disabled={true}
													value={payment?.payment?.card_info?.expiry_date || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.quotes && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.quota')}
													disabled={true}
													value={payment?.payment?.card_info?.quotes || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.coupon_code && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.coupon_number')}
													disabled={true}
													value={payment?.payment?.card_info?.coupon_code || ''}
													className="textField"
												/>
											</Grid>}
											{payment?.payment?.card_info?.auth_code && <Grid item xs={12} md={4} lg={4} xl={3} >
												<TextField
													size='small'
													fullWidth
													label={translate('ra.field.auth_code')}
													disabled={true}
													value={payment?.payment?.card_info?.auth_code || ''}
													className="textField"
												/>
											</Grid>}
										</Fragment>
									}
									{payment?.payment?.check_info && <Fragment>
										{payment?.payment?.check_info?.coupon_number && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.coupon_number')}
												disabled={true}
												value={payment?.payment?.check_info?.coupon_number || ''}
												className="textField"
											/>
										</Grid>}
										{payment?.payment?.check_info?.bank_name && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.bank')}
												disabled={true}
												value={payment?.payment?.check_info?.bank_name || ''}
												className="textField"
											/>
										</Grid>}
										{payment?.payment?.check_info?.type && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.check_type')}
												disabled={true}
												value={payment?.payment?.check_info?.type || ''}
												className="textField"
											/>
										</Grid>}
										{payment?.payment?.check_info?.date_emision && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.date_emision')}
												disabled={true}
												value={payment?.payment?.check_info?.date_emision || ''}
												className="textField"
											/>
										</Grid>}
										{payment?.payment?.check_info?.customer_name && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.customer_name')}
												disabled={true}
												value={payment?.payment?.check_info?.customer_name || ''}
												className="textField"
											/>
										</Grid>}
										{payment?.payment?.check_info?.document_number && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.document_number')}
												disabled={true}
												value={payment?.payment?.check_info?.document_number || ''}
												className="textField"
											/>
										</Grid>}
									</Fragment>}

									{payment?.payment?.wallet_info && <Fragment>
										{payment?.payment?.wallet_info?.payment_id && <Grid item xs={12} md={4} lg={4} xl={3} >
											<TextField
												size='small'
												fullWidth
												label={translate('ra.field.payment_id')}
												disabled={true}
												value={payment?.payment?.wallet_info?.payment_id || ''}
												className="textField"
											/>
										</Grid>}
									</Fragment>}

								</Fragment>
							</Grid>
						</Grid>
						{/* End Bloq Detail Payment */}

						{/* Start Bloq Withhold Payment */}
						{payment?.payment?.retentions.length > 0 &&
							<Grid item xs={12} md={12} lg={12} xl={12} >
								<Grid container spacing={3}>
									<Grid item xs={12} md={12} lg={12} xl={12}>
										<PageDividerText content={translate('ra.field.retentions')} />
									</Grid>
									<Grid item xs={12} md={12} lg={12} xl={12}>
										{payment?.payment?.retentions.map((withhold) => (
											<Grid container spacing={3} direction="row" >
												<Grid item xs={12} md={4} lg={4} xl={3} >
													<TextField
														size='small'
														fullWidth
														label={translate('ra.field.type')}
														disabled={true}
														value={withhold.type || ''}

													/>
												</Grid>
												<Grid item xs={12} md={4} lg={4} xl={3} >
													<TextField
														size='small'
														fullWidth
														label={translate('ra.field.amount')}
														disabled={true}
														value={withhold.amount || ''}
													/>
												</Grid>
												<Grid item xs={12} md={4} lg={4} xl={3} >
													<TextField
														size='small'
														fullWidth
														label={translate('ra.field.payment_id')}
														disabled={true}
														value={withhold.certificate || ''}
													/>
												</Grid>

												{/* start - preview ducument */}
												{withhold.files.length > 0 &&
													<Grid item xs={12} md={12} lg={12} xl={12}>
														{withhold.files.length !== 0 ? (
															<div className='previewDowloadableImagesComponent'>
																<div className='containerTitle'>{translate('ra.title.files_uploaded')}</div>
																<div className='list'>
																	{withhold.files.map((file, index) => (
																		<div key={index} className='list-item'>
																			<div className='titleContainer'>
																				<div className='title' >
																					<span style={{ fontSize: 18, fontWeight: 600, color: '#5663c9' }}>{index + 1}</span>
																					{' '} {translate('ra.field.name')}:
																				</div>
																				<div className='fileName'>{file.file_name}</div>
																			</div>

																			<div className='imageContainer'>
																				{file.bucket_path.includes('.pdf') ? (
																					<PDFRenderer url={file.bucket_path} alt={`Vista previa PDF ${index + 1}`} />
																				) : (
																					<CardMedia
																						component="img"
																						image={file.bucket_path}
																						alt={`Vista previa ${index + 1}`}
																						className="image"
																					/>
																				)}
																			</div>

																			<div className='downloadButton'>
																				{/* Botón para abrir vista previa */}
																				<IconButton aria-label="preview" onClick={() => handleOpenPreview(file)}>
																					<Icon>visibility</Icon> {' '}  <span style={{ fontSize: 14 }}>{' '} {translate('ra.action.show')}</span>
																				</IconButton>

																				{/* Botón de descarga existente */}
																				<IconButton aria-label="download" onClick={() => handleDownloadFiles([file])}>
																					<DownloadIcon /> <span style={{ fontSize: 14 }}>{translate('ra.action.download')}</span>
																				</IconButton>
																			</div>
																		</div>
																	))}
																</div>
															</div>
														) : (
															<h1>Cargando...</h1>
														)}
													</Grid>

												}
												{/* end - preview ducument */}
											</Grid>
										))}
									</Grid>
								</Grid>
							</Grid>}
						{/* End Bloq Withhold Payment */}

						<Grid item xs={12} md={12} lg={12} xl={12}>
							<PageDividerText content={translate('ra.title.labelReceiptAndImputation')} />
						</Grid>
						<Grid item xs={12} md={6} lg={6} xl={6} >
							<div style={{display:'flex', flexDirection:'row'}}>
								<TextField
									size='small'
									fullWidth
									label={translate('ra.field.receipt_number')}
									disabled={!editReceipt}
									onChange={(e) => setReceiptNumber(e.target.value)}
									value={receiptNumber}
									className="textField"
									InputProps={{
										endAdornment: (
										editReceipt && !loadingEditReceipt && <InputAdornment position="end">
											<IconButton
												color='success'
												onClick={() => {
													editReceiptNumber()
												}}
												edge="end"
											>
												<DoneIcon />
											</IconButton>
											<IconButton
												color='error'
												onClick={() => {setEditReceipt(false)}}
												edge="end"
											>
												<CloseIcon />
											</IconButton>
										</InputAdornment>
										),
									}}
								/>
								{!editReceipt && <EditIcon 
									onClick={()=>setEditReceipt(true)} 
									color='primary' 
									style={{textAlign:'center', cursor:'pointer', marginLeft:'10px'}}
								/>}
								{
									loadingEditReceipt && <CircularProgress/>
								}
								{
									<LoadingButton
										style={{textAlign:'center', width:'50%', height:'50%',marginLeft:'10px'}}
										variant='contained'
										loading={loadingUpdateReceipt}
										onClick={async()=>{
											await updateReceiptNumber()
										}}
									>
										{translate('ra.action.update_receipt')}
									</LoadingButton>
								}
							</div>
						</Grid>
						{payment?.payment?.allocation_message &&
							<Grid item xs={12} md={12} lg={12} xl={12} >
								<TextField
									size='small'
									fullWidth
									label={translate('ra.field.allocation_message')}
									disabled={true}
									value={payment?.payment?.allocation_message || ''}
									className="textField"
								/>
							</Grid>
						}
						{payment.payment?.files?.length > 0 &&
							<Grid item xs={12} md={12} lg={12} xl={12}>
								{payment.payment?.files?.length !== 0 ? (
									<div className='previewDowloadableImagesComponent'>
										<div className='containerTitle'>{translate('ra.title.files_uploaded')}</div>
										<div className='list'>
											{payment.payment?.files?.map((file, index) => (
												<div key={index} className='list-item'>
													<div className='titleContainer'>
														<div className='title' >
															<span style={{ fontSize: 18, fontWeight: 600, color: '#5663c9' }}>{index + 1}</span>
															{' '} {translate('ra.field.name')}:
														</div>
														<div className='fileName'>{file.file_name}</div>
													</div>
		
													<div className='imageContainer'>
														{file.bucket_path.includes('.pdf') ? (
															<PDFRenderer url={file.bucket_path} alt={`Vista previa PDF ${index + 1}`} />
														) : (
															<CardMedia
																component="img"
																image={file.bucket_path}
																alt={`Vista previa ${index + 1}`}
																className="image"
															/>
														)}
													</div>
		
													<div className='downloadButton'>
														{/* Botón para abrir vista previa */}
														<IconButton aria-label="preview" onClick={() => handleOpenPreview(file)}>
															<Icon>visibility</Icon> {' '}  <span style={{ fontSize: 14 }}>{' '} {translate('ra.action.show')}</span>
														</IconButton>
		
														{/* Botón de descarga existente */}
														<IconButton aria-label="download" onClick={() => handleDownloadFiles([file])}>
															<DownloadIcon /> <span style={{ fontSize: 14 }}>{translate('ra.action.download')}</span>
														</IconButton>
													</div>
												</div>
											))}
										</div>
									</div>
								) : (
									<h1>Cargando...</h1>
								)}
							</Grid>
		
						}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button autoFocus variant="contained" onClick={handleCloseDialogPayment}>
						{translate('ra.action.close')}
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	)
}
export default BillingFormEditDialogPayments